<script>
import { permissionsMixin } from '@/mixins/userPermissions';

 export default {
  mixins: [permissionsMixin],
  
  mounted(){
   this.setPermissions(this.auth);
  },

  methods: {
   isActive(path) {
    return this.$route.path === path;
  },
 },
};
</script>

<template>
<div class="col-xl-3 theiaStickySidebar">
<div class="card">
 <div class="card-body">
  <div class="d-flex flex-column list-group settings-list">
    
    <router-link to="/crm-settings/lead-stages" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Lead', 'read')">
      <i v-if="isActive('/crm-settings/lead-stages')" class="ti ti-arrow-badge-right me-2"></i>Lead Stages</router-link>

    <router-link to="/crm-settings/lead-sources" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Lead', 'read')">
      <i v-if="isActive('/crm-settings/lead-sources')" class="ti ti-arrow-badge-right me-2"></i>Lead Sources</router-link>

    <router-link to="/crm-settings/lead-assignment-rule" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Lead', 'read')">
      <i v-if="isActive('/crm-settings/lead-assignment-rule')" class="ti ti-arrow-badge-right me-2"></i>Source wise Assignment</router-link> 

    <router-link to="/crm-settings/lead-assignment-location-rule" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Lead', 'read')">
      <i i v-if="isActive('/crm-settings/lead-assignment-location-rule')" class="ti ti-arrow-badge-right me-2"></i>Location wise Assignment</router-link> 
      
    <router-link to="/crm-settings/project-pipelines" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Project', 'read')">
      <i v-if="isActive('/crm-settings/project-pipelines')" class="ti ti-arrow-badge-right me-2"></i>Project Pipelines</router-link> 
    
   </div>
  </div>
</div>
</div>
</template>
z